module.exports = __webpack_public_path__ + "img/mingbai2_3bbb3352b.png";